import React from 'react';
import './IconButton.scss';

const IconButton = ({ icon, label, onClick }) => {
  return (
    <button className='icon-button' onClick={onClick}><img src={icon} alt={`${label}-button`} height={10} />{label}</button>
  );
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/IconButton/index.js